module.exports = __webpack_public_path__ + "media/printed-materials/educators-07-high-school-qrg-a7ab5628.png";